/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Trust_Coverage_TitleInputs */

const en_home_trust_coverage_title = /** @type {(inputs: Home_Trust_Coverage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worldwide Coverage`)
};

const fr_home_trust_coverage_title = /** @type {(inputs: Home_Trust_Coverage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couverture mondiale`)
};

/**
* | output |
* | --- |
* | "Worldwide Coverage" |
*
* @param {Home_Trust_Coverage_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_trust_coverage_title = /** @type {((inputs?: Home_Trust_Coverage_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trust_Coverage_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_trust_coverage_title(inputs)
	return fr_home_trust_coverage_title(inputs)
});